import { render, staticRenderFns } from "./TokenRefresh.vue?vue&type=template&id=1d5f45a2"
import script from "./TokenRefresh.vue?vue&type=script&lang=js"
export * from "./TokenRefresh.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports